import { createContext } from 'react'
import { Sport } from '../types'

export const SportContext = createContext<{
  sports: Sport[]
  isLoaded: boolean
}>({ sports: [], isLoaded: false })
